var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeometry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.43 30.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Geometry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-864.13-2.18a15.36,15.36,0,0,0-1.29-5.55l-1.77.79a13.44,13.44,0,0,1,1.12,4.77H-878.3l3.58-11.92a13.67,13.67,0,0,1,4.42,2.76l1.33-1.41a15.6,15.6,0,0,0-5.19-3.2L-870-30l-1.86-.56-9.1,30.34h29.43V-2.18h-12.64Z",
    transform: "translate(880.91 30.58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-859.73-8a3.39,3.39,0,0,0,3.39-3.39,3.39,3.39,0,0,0-3.39-3.39,3.39,3.39,0,0,0-3.39,3.39A3.39,3.39,0,0,0-859.73-8Zm0-4.85a1.45,1.45,0,0,1,1.45,1.45,1.45,1.45,0,0,1-1.45,1.45,1.45,1.45,0,0,1-1.45-1.45A1.45,1.45,0,0,1-859.73-12.84Z",
    transform: "translate(880.91 30.58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-868-8.54l1.65-1a15.83,15.83,0,0,0-1.2-1.69l-1.5,1.22A13.76,13.76,0,0,1-868-8.54Z",
    transform: "translate(880.91 30.58)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometry);
export default __webpack_public_path__ + "static/media/Geometry.88f9765b.svg";
export { ForwardRef as ReactComponent };